// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ExternalReferenceSchema = z.object({
  id: z.number().int(),
  provider_type: z.coerce.string(),
  provider_id: z.coerce.string(),
  updated_at: z.string().datetime(),
  connection_id: z.number().int(),
  url: z.coerce.string().url(),
});
